import ReactJson from "@microlink/react-json-view"
import { useIslandProps } from "@archipelago-js/react"
import React from "react"

const THEME = {
  base00: "transparent",
  base01: "#f5f5f5",
  base02: "#e0e0e0",
  base03: "#9e9e9e",
  base04: "#6b7280",
  base05: "#374151",
  base06: "#1f2937",
  base07: "#111827",
  base08: "#ef4444",
  base09: "#f97316",
  base0A: "#eab308",
  base0B: "#22c55e",
  base0C: "#06b6d4",
  base0D: "#6366f1",
  base0E: "#a855f7",
  base0F: "#ec4899",
}

export default function JsonViewer() {
  const { props } = useIslandProps()
  return (
    <ReactJson
      src={props.body as object}
      collapsed={2}
      name={false}
      theme={THEME}
      displayDataTypes={false}
      displayObjectSize={true}
      enableClipboard={true}
      style={{ fontSize: "0.75rem", fontFamily: "ui-monospace, monospace" }}
    />
  )
}